import $ from 'jquery';
import Accordion from '../util/Accordion';
import Api from '../util/Api';
import CommonHelper from '../util/CommonHelper';
import Popup from '../util/Popup';
import SelectService from "../service/SelectService";


// Скрипты оформления
const orderContainer = $('.order');
if (orderContainer.length) {
    $('.header-city').addClass('disabled');
    const radioSplitOrder = $('[name=order_split]');
    const allTables = $('.accordion--products');
    const allProductsTable = $('[data-type=ALL]');
    const onlineProductsTable = $('[data-type=ONLINE]');
    const offlineProductsTable = $('[data-type=OFFLINE]');
    const orderSplitStep = $('.order-split');
    let visibleAccordions = $('.order .accordion:visible');

    if (orderSplitStep.length) {
        allTables.hide();
    } else {
        Accordion.open(visibleAccordions[0]);
    }

    if (onlineProductsTable.length && offlineProductsTable.length) {
        onlineProductsTable.show();
        offlineProductsTable.show();
    }

    radioSplitOrder.change(function () {
        const value = radioSplitOrder.filter(':checked').val();
        switch (value) {
            case 'y':
                allTables.hide();
                onlineProductsTable.show();
                offlineProductsTable.show();
                break;
            case 'n':
                allTables.hide();
                allProductsTable.show();
                break;
            default:
                break;
        }
    });

    $('.order__next').click(function () {
        visibleAccordions = $('.order .accordion:visible');
        const currentAccordion = $(this).closest('.accordion');
        const currentAccordionIndex = visibleAccordions.index(currentAccordion);
        const nextAccordion = visibleAccordions[currentAccordionIndex + 1];

        if (nextAccordion) {
            Accordion.closeAll();
            Accordion.open(nextAccordion);
            CommonHelper.scrollToSelector(nextAccordion);
        }
    });

    $('.order__prev').click(function () {
        visibleAccordions = $('.order .accordion:visible');
        const currentAccordion = $(this).closest('.accordion');
        const currentAccordionIndex = visibleAccordions.index(currentAccordion);
        const prevAccordion = visibleAccordions[currentAccordionIndex - 1];

        if (prevAccordion) {
            Accordion.closeAll();
            Accordion.open(prevAccordion);
            CommonHelper.scrollToSelector(prevAccordion);
        }
    });

    // Автозаполнение адреса
    let allCities = [];
    let stateNames = {};
    setTimeout(function () {
        Api.get('/api/places/find-city/', {query: ''}).then((response) => {
            if (response.status === 'success') {
                allCities = response.result.map((city) => {
                    return {...city, nameLower: city.name.toLowerCase()}
                });
            }
        });
    }, 1000);
    setTimeout(function () {
        Api.get('/api/places/find-state/', {query: ''}).then((response) => {
            if (response.status === 'success') {
                response.result.forEach((state) => {
                    stateNames[state.id] = state.name;
                });
            }
        });
    }, 1500);

    let isAddressChanging = false;
    let selectedState = null;

    $('[name=DELIVERY_ADDRESS_COUNTRY]').on('change', function () {
        if ($(this).val() === 'India') {
            $('.control--india').removeClass('hidden');
            $('.control--other-country').addClass('hidden');
        } else {
            $('.control--india').addClass('hidden');
            $('.control--other-country').removeClass('hidden');
        }
    });

    SelectService.onChange('delivery-address-state', function (value) {
        if (!value) {
            selectedState = null;
            return;
        }
        if (value === selectedState) {
            return;
        }

        if (selectedState) {
            SelectService.setValue('delivery-address-city', false);
            SelectService.setOptions('delivery-address-city', []);
        }

        selectedState = value;
        // const filteredCities = allCities.filter(city => city.state_id === selectedState);

        // SelectService.setOptions('delivery-address-city', filteredCities);
        // SelectService.setOptions('delivery-address-postcode', filteredCities.map((city) => {
        //     return {
        //         id: city.id,
        //         name: city.pin,
        //     };
        // }), true, 'name');

        $('[name=DELIVERY_ADDRESS_STATE]').val(stateNames[selectedState] || '-');
    });

    SelectService.onChange('delivery-address-city', function (value) {
        if (!value || isAddressChanging) {
            return;
        }
        isAddressChanging = true;

        if (!selectedState) {
            const selectedCity = allCities.find(city => city.id === value);
            SelectService.setValue('delivery-address-state', selectedCity.state_id);
        }
        // SelectService.setValue('delivery-address-postcode', value);

        setTimeout(() => {isAddressChanging = false;}, 200);
    });

    SelectService.onInput('delivery-address-city', function (value) {
        if (value.length) {
            if (!selectedState) {
                SelectService.setOptions('delivery-address-city', allCities.filter((city) => {
                    return city.nameLower.indexOf(value.toLowerCase()) === 0;
                }));
            } else {
                SelectService.setOptions('delivery-address-city', allCities.filter((city) => {
                    return city.state_id === selectedState && city.nameLower.indexOf(value.toLowerCase()) === 0;
                }));
            }
        } else {
            SelectService.setOptions('delivery-address-city', []);
        }
    });

    // SelectService.onChange('delivery-address-postcode', function (value) {
    //     if (!value || isAddressChanging) {
    //         return;
    //     }
    //     isAddressChanging = true;
    //
    //     if (!selectedState) {
    //         const selectedCity = allCities.find(city => city.id === value);
    //         SelectService.setValue('delivery-address-state', selectedCity.state_id);
    //     }
    //     SelectService.setValue('delivery-address-city', value);
    //
    //     setTimeout(() => {isAddressChanging = false;}, 200);
    // });
    //
    // SelectService.onInput('delivery-address-postcode', function (value) {
    //     if (!selectedState) {
    //         if (value.length >= 3) {
    //             SelectService.setOptions('delivery-address-postcode', allCities.filter((city) => {
    //                 return city.pin.indexOf(value) !== -1;
    //             }).map((city) => {
    //                 return {
    //                     id:  city.id,
    //                     name: city.pin,
    //                 };
    //             }), true, 'name');
    //         } else {
    //             SelectService.setOptions('delivery-address-postcode', []);
    //         }
    //     }
    // });

    // Выбор адреса из сохранённых
    SelectService.onChange('delivery-address', function (value) {
        $('.order-delivery-courier__fields').toggleClass('hidden', value !== 'new');
        // $('.order-delivery-courier__fields input[data-required]').prop('required', value === 'new');

        const addressFields = {
            country:    'DELIVERY_ADDRESS_COUNTRY',
            state:      'DELIVERY_ADDRESS_STATE',
            city:       'DELIVERY_ADDRESS_CITY',
            street:     'DELIVERY_ADDRESS_STREET',
            apartment:  'DELIVERY_ADDRESS_APARTMENT',
            pin:        'DELIVERY_ADDRESS_POSTCODE',
        };

        if (value !== 'new') {
            const props = window.addresses[value].properties;

            SelectService.setValue('delivery-address-state', false);
            SelectService.setValue('delivery-address-city', false);
            // SelectService.setValue('delivery-address-postcode', false);

            Object.keys(addressFields).forEach((field) => {
                $(`[name=${addressFields[field]}]`).val(props[field]).prop('required', false);
                $('[name=DELIVERY_ADDRESS_STATE_ID]').prop('required', false);
            });
        } else {
            Object.keys(addressFields).forEach((field) => {
                const input = $(`[name=${addressFields[field]}]`);
                input.val(input.data('default') || '').prop('required', true);
            });
            $('[name=DELIVERY_ADDRESS_STATE_ID]').prop('required', true);

            $(`[name=${addressFields.city}] + .control-select-body__placeholder`).removeClass('hidden');
            // $(`[name=${addressFields.pin}] + .control-select-body__placeholder`).removeClass('hidden');
        }

        $(`[name=${addressFields.country}]`).change();
    });

    $('.order__submit').click(function () {
        const emailDomInput = $('input[name=new_email]');
        const nameDomInput = $('input[name=new_name]');
        const phoneDomInput = $('input[name=new_name]');
        if (!(nameDomInput.val() && phoneDomInput.val() && emailDomInput && emailDomInput[0].checkValidity())) {
            Accordion.open(visibleAccordions[0]);
        }
    });


    let isOrderFormInProgress = false;
    $('.order-form').submit(function (e) {
        e.preventDefault();

        const data = {};
        $(this).serializeArray().forEach((param) => {
            data[param.name] = param.value;
        });
        // $('.order__submit').addClass('disabled');
        Popup.notify('<div>Checkout in progress, please wait</div> <div class="popup__loader"></div>', false);
        // Api.post('/api/order/make/', params)
        //     .then((response) => {
        //         if (response.isok) {
        //             Popup.notify(response.message);
        //             setTimeout(() => {
        //                 window.location.href = '/personal/orders';
        //             }, 500);
        //         } else {
        //             $('.order__submit').removeClass('disabled');
        //             Popup.notify('Что-то пошло не так, проверьте является ли введённый телефон верным.');
        //         }
        //     })
        //     .catch(() => {
        //         $('.order__submit').removeClass('disabled');
        //         Popup.notify('Что-то пошло не так, проверьте является ли введённый телефон верным.');
        //     });

        if (isOrderFormInProgress) {
            return;
        }
        isOrderFormInProgress = true;
        Api.post('/api/order/create/', data)
            .then((response) => {
                if (response.status === 'success') {
                    Popup.notify(response.message);
                    setTimeout(() => {
                        window.location.href = '/personal/orders?new_id=' + response.orders[0];
                    }, 1500);
                } else {
                    Popup.notify(response.errorMessage);
                }
            })
            .catch(() => {
                isOrderFormInProgress = false;
                Popup.notify('Something went wrong, check if the entered data is correct.');
            });
    });

    $('.accordion:not(.accordion--standalone) .accordion-title').click(function () {
        const currentAccordion = $(this).closest('.accordion');
        Accordion.closeAll();
        Accordion.open(currentAccordion);
        CommonHelper.scrollToSelector(currentAccordion);
    });

    $('.accordion.accordion--standalone .accordion-title').click(function () {
        const currentAccordion = $(this).closest('.accordion');
        Accordion.toggle(currentAccordion);
    });
}
// Скрипты списка
$('.order-popup').click(function () {
    const $html = $(this).closest('.accordion').find('.order-detail').html();
    Popup.orderDetail($html);
});

$('.order-cancel').click(function (e) {
    e.preventDefault();
    const params = {};
    const orderId = $(this).closest('.accordion--order').attr('data-order');
    params.order_id = orderId;
    $(this).addClass('disabled');
    Api.post('/api/order/cancel/', params)
        .then((response) => {
            if (response.error) {
                Popup.notify(response.error);
                $(this).removeClass('disabled');
            } else {
                if (response.message) {
                    Popup.notify(response.message);
                }
                setTimeout(() => {
                    window.location.reload();
                }, 1200);
            }
        });
});

$('.order-repeat').click(function (e) {
    e.preventDefault();
    const params = {};
    const orderId = $(this).closest('.accordion--order').attr('data-order');
    params.order_id = orderId;
    $(this).addClass('disabled');
    Api.post('/api/order/repeat/', params)
        .then((response) => {
            if (response.error) {
                Popup.notify(response.error);
                $(this).removeClass('disabled');
            } else {
                if (response.message) {
                    Popup.notify(response.message);
                }
                window.location.href = '/basket';
            }
        });
});
